import { DeleteRowsRequestDto } from '@asset-metrix/portal-gateway-client-js';

import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const datatableDeleteRows = async ({
  widgetId,
  data,
}: {
  widgetId: string;
  data: DeleteRowsRequestDto;
}) => {
  const res = await portalGatewayClient.table.deleteTableRows(widgetId, data);

  if (res.ok) {
    return res.data;
  }

  throw new HttpError('Error deleting rows', res);
};
